import * as XLSX from "xlsx";

export const handleDownloadXLSX = async (data, fileName) => {
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  // Create a workbook
  const workbook = XLSX.utils.book_new();

  // Add a worksheet with the data
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Convert the workbook to a binary string
  const binaryString = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "binary",
  });

  // Convert the binary string to a Blob
  const blob = new Blob([s2ab(binaryString)], {
    type: "application/octet-stream",
  });

  // Create a download link
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName || "file"}.xlsx`;

  // Trigger a click event to download the file
  a.click();

  // Clean up the URL.createObjectURL
  URL.revokeObjectURL(url);
};

export const multiDownloadXLSX = async (data, fileName) => {
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  // Create a workbook
  const workbook = XLSX.utils.book_new();

  // Add a worksheet with the data
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Convert the workbook to a binary string
  const binaryString = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "binary",
  });

  // Convert the binary string to a Blob
  const blob = new Blob([s2ab(binaryString)], {
    type: "application/octet-stream",
  });

  // Create a download link
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName || "file"}.xlsx`;

  // Trigger a click event to download the file
  a.click();

  // Clean up the URL.createObjectURL
  URL.revokeObjectURL(url);
};

// var ws_data = [
//   ["Column 1"],
//   [1]
// ];
// var ws = XLSX.utils.aoa_to_sheet(ws_data);

// var ws_data2 = [
//   ["Column 2"],
//   [2]
// ];
// var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);

// const wb = XLSX.utils.book_new();
// XLSX.utils.book_append_sheet(wb, ws, "SheetJS1");
// XLSX.utils.book_append_sheet(wb, ws2, "SheetJS2");

// XLSX.writeFile(wb, "sheetjs.xlsx");
